"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _colors = require("../../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BOIWhiteLogo =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BOIWhiteLogo, _PureComponent);

  function BOIWhiteLogo() {
    _classCallCheck(this, BOIWhiteLogo);

    return _possibleConstructorReturn(this, _getPrototypeOf(BOIWhiteLogo).apply(this, arguments));
  }

  _createClass(BOIWhiteLogo, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          fill: color
        },
        viewBox: "0 0 53.788 28.224"
      }, _react2.default.createElement("g", {
        fillRule: "evenodd"
      }, _react2.default.createElement("path", {
        d: "M26.894,28.224c-7.2,0-13.953-1.462-19.021-4.116a18.009,18.009,0,0,1-5.761-4.484A8.716,8.716,0,0,1,0,14.112,8.711,8.711,0,0,1,2.114,8.6,18.029,18.029,0,0,1,7.878,4.116C12.949,1.462,19.7,0,26.894,0S40.838,1.462,45.909,4.116A18.03,18.03,0,0,1,51.673,8.6a8.711,8.711,0,0,1,2.114,5.512,8.716,8.716,0,0,1-2.112,5.512,18.01,18.01,0,0,1-5.761,4.484C40.847,26.762,34.091,28.224,26.894,28.224Zm.065-26.907C14.152,1.317,3.732,7.05,3.732,14.1a8.1,8.1,0,0,0,1.82,4.973,15.728,15.728,0,0,0,4.963,4.062,34.542,34.542,0,0,0,16.379,3.744l.065-.016a34.542,34.542,0,0,0,16.379-3.744A15.728,15.728,0,0,0,48.3,19.054a8.1,8.1,0,0,0,1.82-4.973A8.084,8.084,0,0,0,48.3,9.109a15.731,15.731,0,0,0-4.967-4.057A34.588,34.588,0,0,0,26.959,1.317Z",
        transform: "translate(0 0)"
      }), _react2.default.createElement("path", {
        d: "M11.507,5.316c.44-2.4,11.279-2.728,11.279-5.174A.127.127,0,0,1,22.9.016a.116.116,0,0,1,.087.037.107.107,0,0,1,.027.088v2.6c0,3.136-10.9,2.7-11.409,5.66,0,0,0,.125-.1.125s-.081,0-.1-.125C10.888,5.441,0,5.833,0,2.744V.125A.128.128,0,0,1,.13,0,.127.127,0,0,1,.244.125c0,2.462,10.839,2.791,11.279,5.174",
        transform: "translate(15.452 5.504)"
      }), _react2.default.createElement("path", {
        d: "M11.507,5.3c.44-2.4,11.279-2.728,11.279-5.174a.114.114,0,0,1,.228,0V2.714c0,3.136-10.9,2.7-11.409,5.66,0,0,0,.125-.1.125s-.081,0-.1-.125C10.888,5.411,0,5.818,0,2.714V.111A.108.108,0,0,1,.039.027.117.117,0,0,1,.13,0a.112.112,0,0,1,.114.11c0,2.446,10.839,2.775,11.279,5.174",
        transform: "translate(15.452 10.802)"
      }), _react2.default.createElement("path", {
        d: "M11.507,5.3c.44-2.4,11.279-2.728,11.279-5.19a.114.114,0,0,1,.228,0V2.728c0,3.136-10.9,2.681-11.409,5.66,0,0,0,.11-.1.11s-.081,0-.1-.11C10.888,5.41,0,5.817,0,2.728V.11A.129.129,0,0,1,.13,0,.128.128,0,0,1,.244.11C.244,2.572,11.083,2.9,11.524,5.3",
        transform: "translate(15.452 16.213)"
      })));
    }
  }]);

  return BOIWhiteLogo;
}(_react.PureComponent);

BOIWhiteLogo.defaultProps = {
  color: _colors.fontColorSecondary
};
exports.default = BOIWhiteLogo;